
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deliver",
      function () {
        return require("private-next-pages/deliver.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deliver"])
      });
    }
  